import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { createTranslatedText, TranslatedText } from '@dreryk/react-common';

export const getPractitionerName = (practitioner: AppointmentPractitioner): TranslatedText => {
   return createTranslatedText(`${practitioner.firstName.asString()} ${practitioner.lastName.asString()}`);
};
